import React from 'react';
import logopng from './Generalfiles/images/logopng.png';

const Preloader = ({ label = 'Opening your desk', compact = false }) => {
    return (
        <div className={compact ? 'crm-preloader crm-preloader-compact' : 'crm-preloader'} role="status" aria-live="polite">
            <div className="crm-preloader-card">
                <img src={logopng} alt="Tabex" />
                <div className="crm-preloader-track">
                    <span />
                </div>
                <p>{label}</p>
            </div>
        </div>
    );
};

export default Preloader;
